import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import {hasPermission} from "../../utils/permissions";

// initial state
const state = {
  sofwareFilterProduct: 'all',
  user: {},
  users: [],
  adminUsers: [],
  // org_users: [],
  assign_to_user: [],
  reports:[],
  // getQa:[],
  products: [],
  demoRequests: {},
  demoLeads: [],
  onBoarding: [],
  demoRequest: [],
  leadNotes: [],
  totalLeads: 0,
  team_id:'',
  user_id:'',
  startDate:'',
  endDate:'',
  search:'',
  totalRows: 0,
  // totalOrganizations:0,
  demoRequestNotes: [],
  notifications: [],
  // notificationsStatus: "all",
  notificationsSearch : "",
  usersSearch: [],
  totalPages: 0,
  organizations: [],
  organizationId: localStorage.getItem('organization'),
  // availableProducts: [],
  // userProducts: {},
  // activeProducts: {},
  tags:[],
  currentPage:1,
  totalRecords:0,
  status:[],
  type:[],
  search:[],
  setSelectedOrg:[],
  userCurrentPage:1,
  userRoleBasedList:[],
  // userRoles: {
  //   super_admin:0,
  //   admin: 1,
  //   crm: 2,
  //   editor: 3,
  //   support: 4,
  //   data_entry: 5,
  //   digital_marketing: 6,
  //   adh: 7,
  //   development_lead: 8,
  //   developer: 9,
  //   csm: 10,
  //   adh_helper: 11,
  //   qa:12,
  // },
  // selectLeadList:[
  //   { name: 'outbound', value: '1' },
  //   { name: 'inbound', value: '2' },
  // ],
}

// getters
const getters = {
  // orgUsers: (state) => {
  //   return state.org_users;
  // },
  assignToUser: (state) => {
    return state.assign_to_user;
  },
  // selectLeadList:(state) =>{
  //   return state.selectLeadList;
  // },
  // availableProducts: (state) => {
  //   return state.availableProducts;
  // },
  sofwareFilterProduct: (state) => {
    return state.sofwareFilterProduct;
  },
  get_team:(state)=>{
    return state.team_id;
  },
  get_user:(state)=>{
    return state.user_id;
  },
  startdate:(state)=>{
    return state.startDate;
  },
  enddate:(state)=>{
    return state.endDate;
  },
  search:(state)=>{
    return state.search;
  },
  user: (state) => {
    return state.user;
  },
  users: (state) => {
    return state.users;
  },
  adminUsers: (state) => {
    return state.adminUsers;
  },
  reports:(state) => {
    return state.reports;
  },
  // getQa: (state) => {
  //   return state.getQa;
  // },
  products: (state) => {
    return state.products;
  },
  notifications: (state) => {
    return state.notifications;
  },
  // notificationsStatus: (state) => {
  //   return state.notificationsStatus;
  // },
  notificationsSearch: (state) => {
    return state.notificationsSearch;
  },
  currentPage: (state) =>{
    return state.currentPage;
  },
  userCurrentPage: (state)=>{
    return state.userCurrentPage;
  },
  demoRequests: (state) => {
    return state.demoRequests;
  },
  demoLeads: (state) => {
    return state.demoLeads;
  },
  onBoarding: (state) => {
    return state.onBoarding;
  },
  totalLeads: (state) => {
    return state.totalLeads;
  },
  totalRows: (state) => {
    return state.totalRows;
  },
  demoRequest: (state) => {
    return state.demoRequest;
  },
  demoRequestNotes: (state) => {
    return state.demoRequestNotes;
  },
  leadNotes: (state) => {
    return state.leadNotes;
  },
  onBoarding: (state) => {
    return state.onBoarding;
  },
  totalPages: (state) => {
    return state.totalPages;
  },
  usersSearch: (state) => {
    return state.usersSearch;
  },
  // totalOrganizations: (state) => {
  //   return state.totalOrganizations;
  // },
  organizations: (state) => {
    return state.organizations;
  },
  organizationId: (state) => {
    return state.organizationId;
  },
  // userProducts: (state) => {
  //   return state.userProducts;
  // },
  // activeProducts: (state) => {
  //   return state.activeProducts;
  // },
  tags: (state) => {
    return state.tags;
  },
  totalRecords: (state) => {
    return state.totalRecords;
  },
  status: (state) => {
    return state.status;
  },
  type: (state) => {
    return state.type;
  },
  search: (state) => {
    return state.search;
  },
  setSelectedOrg: (state) => {
    return state.setSelectedOrg;
  },
  userRoleBasedList:(state) => {
    return state.userRoleBasedList;
  },
  // userRoles:(state) => {
  //   return state.userRoles;
  // },
}

// mutations
const mutations = {
  // ORG_USERS: function (state, org_users) {
  //   state.org_users = org_users;
  // },
  ASSIGN_USER: function (state, assign_to_user){
    state.assign_to_user = assign_to_user;
  },
  // SET_AVAILABLE_PRODUCTS(state, availableProducts) {
  //   state.availableProducts = availableProducts;
  // },
  SET_SOFTWARE_PRODUCT(state, sofwareFilterProduct) {
    state.sofwareFilterProduct = sofwareFilterProduct;
  },
  SET_USER(state, user) {
    state.user = user;
  },

  SET_USERS(state, users) {
    state.users = users;
  },
  SET_STATUS(state, status) {
    state.status = status;
  },
  SET_TYPE(state, type) {
    state.type = type;
  },
  SET_SEARCH(state, search) {
    state.search = search;
  },
  SET_SELECTED_ORG(state, setSelectedOrg) {
    state.setSelectedOrg = setSelectedOrg;
  },
  SET_ADMIN_USERS(state, adminUsers) {
    state.adminUsers = adminUsers;
  },
  SET_REPORTS(state, reports){
    state.reports = reports;
  },
  // SET_QA_USERS(state, getQa){
  //   state.getQa = getQa;
  // },
  SET_PRODUCTS(state, products){
    state.products = products;
  },
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications;
  },
  // SET_NOTIFICATIONS_STATUS(state, notificationsStatus) {
  //   state.notificationsStatus = notificationsStatus;
  // },
  SET_CURRENT_PAGE(state,currentPage){
    state.currentPage = currentPage;
  },
  SET_USER_CURRENT_PAGE(state,userCurrentPage){
    state.userCurrentPage = userCurrentPage;
  },
  SET_NOTIFICATIONS_SEARCH(state, notificationsSearch){
    state.notificationsSearch = notificationsSearch;
  },
  SET_DEMO_REQUESTS(state, demoRequests) {
    state.demoRequests = demoRequests;
  },
  
  SET_DEMO_LEADS(state, demoLeads) {
    state.demoLeads = demoLeads;
  },
  SET_ON_BOARDING(state, onBoarding) {
    state.onBoarding = onBoarding;
  },
  SET_REQUEST(state, demoRequest) {
    state.demoRequest = demoRequest;
  },
  SET_TEAM_ID(state,team_id){
    state.team_id=team_id;
  },
  SET_USER_ID(state,user_id){
    state.user_id=user_id;
  },
  SET_STARTDATE(state,startDate){
    state.startDate=startDate;
  },
  SET_ENDDATE(state,endDate){
    state.endDate=endDate;
  },
  SET_SEARCH(state,search){
    state.search=search;
  },
  SET_REQUEST_NOTES(state, demoRequestNotes) {
    state.demoRequestNotes = demoRequestNotes;
  },
  SET_LEAD_NOTES(state, leadNotes) {
    state.leadNotes = leadNotes;
  },
  SET_onBoarding(state, onBoarding) {
    state.onBoarding = onBoarding;
  },
  SET_USERS_SEARCH(state, users) {
    state.usersSearch = users;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },
  SET_TOTAL_LEADS(state, totalLeads) {
    state.totalLeads = totalLeads;
  },
  SET_TOTAL_ROWS(state, totalRows) {
    state.totalRows = totalRows;
  },
  SET_TOTAL_RECORDS(state, totalRecords){
    state.totalRecords = totalRecords;
  },
  // SET_TOTAL_ORGANIZATIONS(state, totalOrganizations){
  //   state.totalOrganizations = totalOrganizations;
  // },
  SET_ORGANIZATIONS(state, organizations) {
    state.organizations = organizations;
  },
  SET_ORGANIZATION_ID(state, organizationId) {
    localStorage.setItem('organization', organizationId);
    state.organizationId = organizationId;
  },
  ADD_DEMOREQUEST(state, demo) {
    state.demoRequests.push(JSON.parse(JSON.stringify(demo)));
  },
  UPDATE_USER(state, user) {
    let userIndex = state.users.findIndex((item) => {
      return item.id == user.id;
    });
    Vue.set(state.users, userIndex, user);
  },

  DELETE_USER(state, user) {
    let index = state.users.indexOf(user);
    if (index > -1) {
      state.users.splice(index, 1);
    }
  },
  // USER_PRODUCTS(state, userProducts){
  //   state.userProducts = userProducts;
  // },
  // ACTIVE_PRODUCTS(state,activeProducts){
  //   state.activeProducts = activeProducts;
  // },
  SET_DEMO_TAGS(state, tags) {
    state.tags = tags;
  },
  SET_USER_ROLE_BASED_LIST(state, userRoleBasedList){
    state.userRoleBasedList = userRoleBasedList;
  }
}

// actions
const actions = {

  // =========================Create User=================================

  create_user({ commit },user) {
    axios.post('/admin/users/create-user', user);
  },
  update_user({ commit },user) {
    axios.post('/admin/users/update-user', user);
  },

  async getAllUsersLog({ commit}, page) {
    await axios.get('/admin/users/log?page=' + page )
      .then((response) => {
        let res = response.data;
        commit('SET_USERS', res.data);

        let totalPages = Math.ceil(res.total / res.per_page);
        commit('SET_TOTAL_PAGES', totalPages);
      });
  },

  // =========================================================================

  async getAllDemoRequests({ commit, dispatch }, [page, search = "", status, request_from = "", request_to = "", follow_up_from = "", follow_up_to = "", direction = "", column = "", color = "", followup_filter = 10, demo_filter = 'all', software_filter = 'all' , assigned_filter = 'all', crm_id = '', tags_filter = 0,  fromDate, toDate, lead_filter='all']) {
    fromDate = fromDate || moment().startOf('year').format('YYYY-MM-DD');
    toDate = toDate || moment().endOf('month').format('YYYY-MM-DD');
    if(hasPermission('lead_list')){
      const permission = {
        headers: {
          'X-Permission': 'lead_list'
        }
      };
      await axios.get('/admin/users/get-demo-requests?page=' + page + '&baned=' + '&follow_up_from=' + follow_up_from + '&follow_up_to=' + follow_up_to + '&status=' + status + '&request_from='
          + request_from + '&request_to=' + request_to + '&direction=' + direction + '&column=' + column + '&color=' + color + '&search=' + search + '&followup_filter=' + followup_filter +
          '&demo_filter=' + demo_filter + '&software_filter=' + software_filter + '&assigned_filter=' + assigned_filter + '&crm_id=' + crm_id + '&tags_filter=' +tags_filter +
          '&lead_for=' +localStorage.getItem('product')+'&fromDate='+fromDate+'&toDate='+toDate+'&lead_filter=' +lead_filter,permission)

          .then((response) => {
            let res = response.data;
            // commit('USER_PRODUCTS',res.user_product);
            dispatch('persist/setUserProducts', res.user_product, { root: true });
            dispatch('persist/setAvailableProducts', res.active_products, { root: true });
            // commit('ACTIVE_PRODUCTS',res.active_products);
            commit('SET_SOFTWARE_PRODUCT', software_filter);
            commit('SET_DEMO_REQUESTS', res.data.leads);
            commit('SET_DEMO_TAGS',res.all_tags);
            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_LEADS', res.total);
            commit('SET_TOTAL_PAGES', totalPages);
            commit('SET_TOTAL_ROWS', res.data.displayRows);

          }).catch(error => {
          });
    }
  },
  async leadRecevied({commit},{formData}){
    if(hasPermission('onboarding_list')){
      const permission = {
        headers: {
          'X-Permission': 'onboarding_list',
        }
      };
      return await axios.post("/admin/users/recevied-date",{formData},permission).then((res)=>{
        let resp = res.data;
        return resp;
      });
    }
  },
  async getAllDemoLeads({ commit }, [page, search = "", status = "", request_from = "", request_to = "", follow_up_from = "", follow_up_to = "", direction = "", column = "", color = "", tab, ]) {
    if(hasPermission('onboarding_list')){
      const permission = {
        headers: {
          'X-Permission': 'onboarding_list'
        }
      };
      await axios.get('/admin/users/get-demo-leads?page=' + page + '&baned=' + '&follow_up_from=' + follow_up_from + '&follow_up_to=' + follow_up_to + '&status=' + status  + '&request_from=' + request_from + '&request_to=' + request_to + '&direction=' + direction + '&column=' + column + '&color=' + color + '&search=' + search + '&tab=' + tab,permission)
          .then((response) => {
            let res = response.data;
            commit('SET_DEMO_LEADS', res.data);
            commit('SET_TOTAL_LEADS', res.total);
            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
            commit('SET_TOTAL_ROWS',res.displayRows);
          }).catch(error => {
            console.log(error);
          });
    }
  },
  async getOrgTime({},timezone = ''){
    let org_timezone = (timezone != '') ? timezone : "US/Eastern";
    if(hasPermission('onboarding_list')){
      const permission = {
        headers: {
          'X-Permission': 'onboarding_list'
        }
      };
      return await axios.post('/admin/users/get-org-time',{org_timezone},permission)
          .then((response) => {
            return response.data;
          });
    }
  },
  getDemo({ commit }, id) {
    if(hasPermission('lead_detail')){
      const permission = {
        headers: {
          'X-Permission': 'lead_detail'
        }
      };
      axios.get('/admin/users/getdemo?id=' + id,permission)
          .then((response) => {
            commit('SET_REQUEST', response.data.data);
            commit('SET_REQUEST_NOTES', response.data.demo);
            commit('SET_LEAD_NOTES', response.data.notes);
            commit('SET_onBoarding', response.data.board);
          });
    }
  },

  getLeadNotes({commit}, [key,id]){
    if(hasPermission('lead_detail')){
      const permission = {
        headers: {
          'X-Permission': 'lead_detail'
        }
      };

      axios.get(`/admin/general/notes/${key}/${id}`, permission)
          .then((response) => {
            commit('SET_LEAD_NOTES', response.data.data.notes);
          });
    }
  },
  // =========================================================================

  async getAllOraganizations({ commit, state }, [page, search, status,filter]) {
    if(hasPermission('all_organization_list')){
      const permission = {
        headers: {
          'X-Permission': 'all_organization_list'
        }
      };

      await axios.get('/admin/users/all-organizations-data?page=' + page + '&search=' + search +'&status=' + status + '&product=1' + '&filter=' + filter,permission)
          .then((response) => {
            let res = response.data;
            commit('SET_ORGANIZATIONS', res.data);

            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
            // commit('SET_TOTAL_ROWS', res.per_page);
            commit('SET_TOTAL_ROWS', res.data.length);
            // commit('SET_TOTAL_ORGANIZATIONS', res.total);

          });
    }
  },


  // =========================================================================

  changeStatus({ commit },[status, org_id, trial_end_date]) {
    if(hasPermission('all_organization_update_status')){
      const permission = {
        headers: {
          'X-Permission': 'all_organization_update_status'
        }
      };
      axios.get('/admin/users/change-organization-status?status=' + status + '&org_id=' + org_id + '&trial_end_date=' + trial_end_date,permission)
          .then((response) => {
            return response;
          });
    }

  },

  // =========================================================================

  changeDemoStatus({ commit },[status, demo_usr_id, msg]) {
    if(hasPermission('lead_reject')){
      const permission = {
        headers: {
          'X-Permission': 'lead_reject'
        }
      };
      axios.get('/admin/users/change-demorequest-status?status=' + status + '&id=' + demo_usr_id + '&reject_msg=' + msg,permission)
          .then((response) => {
            // alert('Status Changed!');
            return response;
          });
    }
  },
  changeLeadStatus({ commit },[status, lead_id]) {
    axios.get('/admin/users/change-lead-status?status=' + status + '&id=' + lead_id)
      .then((response) => {
        // alert('Status Changed!');
        return response;
      });
  },

  // =========================================================================

  changeDemoColor({ commit },[color, demo_usr_id]) {
    if(hasPermission('lead_select_pripority')){
      const permission = {
        headers: {
          'X-Permission': 'lead_select_pripority'
        }
      };
      axios.get('/admin/users/change-demorequest-color?color=' + color + '&id=' + demo_usr_id,permission)
          .then((response) => {
            // return response;

          });
    }
  },

  // =========================================================================

  changeFollowupDate({ commit },[followup_date, demo_usr_id]) {
    if (confirm('Are you sure you want to change the followup date?')) {
      axios.get('/admin/users/change-followup-date?date=' + followup_date + '&id=' + demo_usr_id)
        .then((response) => {
          alert('Date Changed!');
        })
    } else {
      location.reload();
    }

  },

  // =========================================================================
  async orgMasterUsers({ commit , dispatch}, orgId) {
    if(hasPermission('lead_select_pripority')){
      const permission = {
        headers: {
          'X-Permission': 'lead_select_pripority'
        }
      };
      return await axios.get(`/admin/users/get-master-users?organization_id=${orgId}`, permission)
          .then((response) => {
            dispatch('persist/ORG_USERS', response.data, { root: true });
            return response.data;
          });
    }

  },

  async assignToUser({ commit }) {
    if(hasPermission('lead_select_pripority')){
      const permission = {
        headers: {
          'X-Permission': 'lead_select_pripority'
        }
      };
      return await axios.get(`/admin/users/assign-user`, permission)
          .then((response) => {
            commit('ASSIGN_USER', response.data); // Commit the fetched users to the state
            return response.data;
          });
    }
  },


  // On boarding post=========================================================================

  async postOnboarding({ commit },[demoId, id, lead_onboaring_id,type, schedule_for , schedule_comment,is_completed,completed_at, completed_comment, add_more, next_expected_date,lead_assign_to_id,zoom_meeting,contact_emails,send_email_for_set_crendentials,org_id,training_session_request_in_followup,onboarding_by,add_more_session,zoom_recording_link='',passcode='']) {
    if(hasPermission('onboarding_list')){
      const permission = {
        headers: {
          'X-Permission': 'onboarding_list'
        }
      };
      return await  axios.post('/admin/users/post-onboarding', {
        id: demoId,lead_onboaring_stage_id:id,lead_onboaring_id:lead_onboaring_id, stage: type, schedule_for:schedule_for, schedule_comment:schedule_comment, completed_status:is_completed, completed_at:completed_at, completed_comment :completed_comment, add_more :add_more, next_expected_date:next_expected_date,assign_to:lead_assign_to_id,send_meeting_link:zoom_meeting,contact_emails:contact_emails,send_email_for_set_crendentials:send_email_for_set_crendentials,org_id:org_id,training_session_request_in_followup:training_session_request_in_followup
        ,onboarding_by,add_more_session,zoom_recording_link,passcode }, permission)
          .then((response)=>{
            localStorage.setItem("onboardPost",response.data.status);
            return response.data;
          }).catch((error) => {
            return error.message;
          });
    }
  },
  async addMore({ commit },[id, lead_onboaring_id,org_id,stage]) {
    if(hasPermission('lead_prospection_question')){
      const permission = {
        headers: {
          'X-Permission': 'lead_prospection_question'
        }
      };
      await  axios.post('/admin/users/add-onboarding-training-session', {
        id,lead_onboaring_id,org_id, stage
      },permission)
          .then((response)=>{
            // localStorage.setItem("onboardPost",response.data.status);
            return response.data.status;
          });
    }

  },
  async updateOnboaringStatus({ commit },[id,status]) {
    if(hasPermission('onboarding_on_hold')){
      const permission = {
        headers: {
          'X-Permission': 'onboarding_on_hold'
        }
      };
      return await  axios.post('/admin/users/update-onboaring-status', {
        id: id,
        status:status
      },permission)
          .then((response)=>{
            let res = response.data;
            return res;
          });
    }
  },
  postSession({ commit },[demoId, requested_date, schedule_comment, final_date, final_comment, received_date, is_completed, type]) {
    axios.post('/admin/users/post-session', {
      id: demoId, requested_date: requested_date, schedule_comment: schedule_comment, final_date: final_date, final_comment, received_date: received_date, is_completed, type
    });
  },

  // =========================================================================

  updateDemoStatus({ commit },[demoId, status]) {
    axios.post('/admin/users/update-demo-status', {
      demoId: demoId, status: status
    });
  },
  async getUserList({},[role_name]){
    if(hasPermission('task_developer_filter')){
      const permission = {
        headers: {
          'X-Permission':"task_developer_filter",
        }
      };
      return  await axios.get('/admin/users/get-adminusers-list/'+role_name,permission).then((response)=>{
        // commit('SET_USER_ROLE_BASED_LIST', res.data);
        return response.data;
      });
    }
  },
  // =========================================================================

  async setOrganizationsStatus({ commit },[status, org_ids,trial_end_date]) {
    if(hasPermission('all_organization_update_status')){
      const permission = {
        headers: {
          'X-Permission': 'all_organization_update_status'
        }
      };
      await axios.get('/admin/users/change-organization-status?status=' + status + '&org_ids=' + org_ids + '&trial_end_date=' + trial_end_date,permission)
          .then((response) => {
            alert('status changed!');
            window.location.reload();
          });
    }
  },

  // =========================================================================

  saveUserNote({ commit },[note, user_id]) {
    if(hasPermission('all_organization_note')){
      const permission = {
        headers: {
          'X-Permission': 'all_organization_note'
        }
      };
      axios.post('/admin/users/save-user-note', {
        note: note, user: user_id
      },permission);
    }

  },
  // =========================================================================
  async updateOrgUser({ commit }, { formData }) {
    if(hasPermission('all_organization_note')){
      const permission = {
        headers: {
          'X-Permission': 'all_organization_note'
        }
      };

      try {
        const response = await axios.post('/admin/users/update-org-user', formData, permission);

        return response.data;
      } catch (error) {
        console.error('Error in updateOrgUser action:', error);
        return { success: false, error };
      }
    }
  },

  // =========================================================================

  sendEmailToOrganization({ commit },[subject, note, user_id]) {
    if(hasPermission('all_organization_email')){
      const permission = {
        headers: {
          'X-Permission': 'all_organization_email'
        }
      };
      axios.post('/admin/users/send-email', {
        subject: subject, note: note, user: user_id
      },permission);
    }
  },

  // =========================================================================

  sendBulkEmailToOrganization({ commit },[subject, note]) {
    axios.post('/admin/users/send-bulk-email', {
      subject: subject, note: note
    });
  },

  // =========================================================================   

  createDemoRequest({ commit },[demo, user_id , additional_info,tag_ids,assign_to,cog_types,lead_type]) {
    if(hasPermission('lead_create')){
      const permission = {
        headers: {
          'X-Permission': 'lead_create'
        }
      };
      return new Promise((resolve, reject) =>
          axios.post('/admin/users/save-demo-requests', {
            user_id: user_id,
            companyName: demo.companyName,
            contactName: demo.contactName,
            phone: demo.phone,
            lead_for: demo.lead_for.id,
            email: demo.email,
            country: demo.country,
            services: demo.servicesValues,
            answer: demo.answer,
            join: demo.joinValue,
            company_url: demo.company_url,
            additional_info:additional_info,
            tag_ids : tag_ids,
            lead_type: lead_type,
            assign_to : assign_to,
            cog_types : cog_types,
          },permission).then(
              (resp) => {
                resolve(resp.data);
              },
              (resp) => {
                reject(resp.data);
              }
          )
      );
    }
  },


  // =========================================================================   

  scheduleDemoMailAjax({ commit },[lead_schedule_demo_id, lead_schedule_demo_name, lead_schedule_demo_email]) {
    if(hasPermission('lead_send_prospection_mail')){
      const permission = {
        headers: {
          'X-Permission': 'lead_send_prospection_mail'
        }
      };
      return new Promise((resolve, reject) =>
          axios.post('/admin/users/schedule-demo-mail', {
            lead_id: lead_schedule_demo_id,
            lead_name: lead_schedule_demo_name,
            lead_email: lead_schedule_demo_email
          }, permission).then(
              (resp) => {
                resolve(resp.data);
              },
              (resp) => {
                reject(resp.data);
              }
          )
      );
    }
  },


  // ========================================================================= 

  updateDemoRequest({ commit },[demo, services, software, additional_info, tag_ids,cog_types,assign_to,lead_type]) {
    if(hasPermission('lead_edit')){
      const permission = {
        headers: {
          'X-Permission': 'lead_edit'
        }
      };
      return new Promise((resolve, reject) =>
          axios.post('/admin/users/update-demo-requests', {
            id: demo.lead_id,
            company: demo.company,
            name: demo.name,
            phone: demo.phone,
            email: demo.email,
            country: demo.country,
            lead_for: software.id,
            services: services,
            company_url: demo.company_url,
            hear_about: demo.hear_about,
            implement_date: demo.implement_date,
            additional_info: additional_info,
            tag_ids: tag_ids,
            cog_types : cog_types,
            assign_to: assign_to,
            lead_type: lead_type,
          },permission).then(
              (resp) => {
                resolve(resp.data);
              },
              (resp) => {
                reject(resp.data);
              }
          )
      );
    }
    // axios.post('/admin/users/update-demo-requests', {
    //   id: demo.lead_id,
    //   company: demo.company,
    //   name: demo.name,
    //   phone: demo.phone,
    //   email: demo.email,
    //   country: demo.country,
    //   services: services,
    //   company_url: demo.company_url,
    //   hear_about: demo.hear_about,
    //   implement_date: demo.implement_date,
    // })
    //   .then((response) => {
    //     let res = response.data;
    //     commit('UPDATE_DEMOREQUEST', response.data.demo);
    //   });
  },

  // =========================================================================

  saveSender({ commit },[user_ids, org_ids, remove_sender_ids]) {
    return axios.post('/admin/users/save-sender', {
      user_ids: user_ids,
      org_ids: org_ids,
      remove_sender_ids: remove_sender_ids,
    }).then((res) => {
      return res;
    });
  },
  // =========================================================================

  sendNotification({ commit },[subject, message, type, notification_id, emails, selectedFile]) {
    const formData = new FormData();
    formData.append('subject', subject);
    formData.append('message', message);
    formData.append('type', type);
    formData.append('id', notification_id);
    formData.append('emails', JSON.stringify(emails));
    formData.append('notification_image', selectedFile);
    if(hasPermission('send_new_list')){
      const permission = {
        headers: {
          'X-Permission': ' send_new_list'
        }
      };
      axios.post('/admin/users/send-notification-all', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...permission.headers
        },
      });
    }
  },

  // =========================================================================

  async getAllnotifications({ commit , dispatch}, [page,status="all",search=""]) {
    commit('SET_NOTIFICATIONS_SEARCH',search);
    // commit('SET_NOTIFICATIONS_STATUS', status);
    dispatch('persist/setNotificationsStatus', status, { root: true });
    commit('SET_CURRENT_PAGE',page);
    if(hasPermission('all_notifications_list')){
      const permission = {
        headers: {
          'X-Permission': 'all_notifications_list'
        }
      };
      await axios.get('/admin/users/get-all-notifications?page=' + page  + '&status=' + status  + '&search='+ search,permission)
          .then((response) => {
            let res = response.data;
            commit('SET_NOTIFICATIONS', res.data);
            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_RECORDS',res.total);
            commit('SET_TOTAL_PAGES', totalPages);
            commit('SET_TOTAL_ROWS', res.display_rows);
          });
    }
  },



  //==============================admin users===========================================
  async getAdminUsers({ commit }, [search = '', role_id='',team_id='']) {
    if(hasPermission('admin_users_list')){
      const permission = {
        headers: {
          'X-Permission': 'admin_users_list'
        }
      };

      await axios.get('/admin/users/get-all-users?search='+ search + '&role_id=' + role_id+ '&team_id=' + team_id,permission)
          .then((response) => {
            let res = response.data;
            commit('SET_ADMIN_USERS', res.data);
            commit('SET_PRODUCTS',res.products);
            let totalPages = Math.ceil(res.total / 300);
            commit('SET_TOTAL_PAGES', totalPages);
            commit('SET_TOTAL_ROWS', res.total);
          });
    }
  },

  async gettaskprogressBySearch ({ commit }, [team_id='',user_id='' , startDate='' , endDate='',search='',product_id='']) {
    commit('SET_TEAM_ID', team_id);
    commit('SET_USER_ID',user_id);
    commit('SET_STARTDATE',startDate);
    commit('SET_ENDDATE',endDate);
    commit('SET_SEARCH',search);
    if(hasPermission('view_task_progress')){
      const permission = {
        headers: {
          'X-Permission': 'view_task_progress'
        }
      };
      await axios.get('/common/task/get-all-taskprogress?team_id=' + team_id+'&user_id=' + user_id +'&startDate=' + startDate +'&endDate=' + endDate +'&search=' + search +'&product_id=' + product_id,permission)
          .then((response) => {

            let res = response.data;
            commit('SET_REPORTS', res.data);
            let totalPages = Math.ceil(res.total / 300);
            commit('SET_TOTAL_PAGES', totalPages);
            commit('SET_TOTAL_ROWS', res.total);

          });
    }

  },
  async getUsers({ commit,dispatch }) {
    if(hasPermission('admin_users_list')){
      const permission = {
        headers: {
          'X-Permission': 'admin_users_list'
        }
      };

      await axios.get('/admin/users/get-users',permission)
          .then((response) => {
            let res = response.data;
            dispatch('persist/SET_QA_USERS', res.data, { root: true });
            // commit('SET_QA_USERS', res.data);
          });
    }
  },
  async getadminusersBySearch({ commit }, [search = '', role_id='',team_id='']) {
    if (search != '') {
      if(hasPermission('admin_users_search')){
        const permission = {
          headers: {
            'X-Permission': 'admin_users_search'
          }
        };
        await axios.get('/admin/users/get-all-users?search=' + search,permission)
            .then((response) => {
              let res = response.data;
              commit('SET_ADMIN_USERS', res.data);
              let displayRows = res.total;
              commit('SET_TOTAL_ROWS', displayRows);
              let totalPages = Math.ceil(res.total / 300);
              commit('SET_TOTAL_PAGES', totalPages);
            });
      }
    } 
    else if (role_id != '') {
      if(hasPermission('admin_users_filter_type')){
        const permission = {
          headers: {
            'X-Permission': 'admin_users_filter_type'
          }
        };
        await axios.get('/admin/users/get-all-users?role_id=' + role_id,permission)
            .then((response) => {

              let res = response.data;
              commit('SET_ADMIN_USERS', res.data);
              let displayRows = res.total;
              commit('SET_TOTAL_ROWS', displayRows);
              let totalPages = Math.ceil(res.total / 300);
              commit('SET_TOTAL_PAGES', totalPages);
            });
      }
    }
    else if (team_id != '') {
      if(hasPermission('admin_users_filter_team')){
        const permission = {
          headers: {
            'X-Permission': ' admin_users_filter_team'
          }
        };

        await axios.get('/admin/users/get-all-users?team_id=' + team_id,permission)
            .then((response) => {
              let res = response.data;

              commit('SET_ADMIN_USERS', res.data);
              let displayRows = res.total;
              commit('SET_TOTAL_ROWS', displayRows);
              let totalPages = Math.ceil(res.total / 300);
              commit('SET_TOTAL_PAGES', totalPages);
            });
      }
    }
     else {
      if(hasPermission('admin_users_search')){
        const permission = {
          headers: {
            'X-Permission': 'admin_users_search'
          }
        };
        await axios.get('/admin/users/get-all-users?search=' + search,permission)
            .then((response) => {
              let res = response.data;
              commit('SET_ADMIN_USERS', res.data);
              let displayRows = res.total;
              commit('SET_TOTAL_ROWS', displayRows);
              let totalPages = Math.ceil(res.total / 300);
              commit('SET_TOTAL_PAGES', totalPages);
            });
      }
    }
  },
  async getAllUsers({ commit, state, rootState}, [page, search, is_subscribed]) {
    await axios({
      method: "get",
      url: '/admin/users?page=' + page + '&search=' + search + '&is_subscribed=' + is_subscribed + '&product=' + rootState.persist.selectedProduct,
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),

    }).then((response) => {
      let res = response.data;
      commit('SET_USERS', res.data);

      let totalPages = Math.ceil(res.total / res.per_page);
      commit('SET_TOTAL_PAGES', totalPages);

    }).catch(err => {
      this.results = err.message;
      throw Error(err.message);
    });
    // }else{
    // axios.get('/admin/users?page=' + page + '&search=' + search + '&is_subscribed=' + is_subscribed)
    // .then((response) => {
    //   let res = response.data;
    //   commit('SET_USERS', res.data);
    //   // commit('SET_USERS', res);
    //   commit('SET_TOTAL_PAGES', 1);
    // });
    // }

  },

  async getOrganizationUsers({ commit, state, rootState }, [page, organization_search, type]) {
    if (!organization_search || organization_search == 'all') {
      await axios.get('/admin/users?page=' + page + '&product=' + rootState.persist.selectedProduct)
        .then((response) => {
          let res = response.data;
          commit('SET_USERS', res.data);
          let totalPages = Math.ceil(res.total / res.per_page);
          commit('SET_TOTAL_PAGES', totalPages);
        })
        .catch((error) => {
          console.error("getOrganizationUsers API error:", error);
        });
    } else {
      if (type !== '') {
        await axios.get('/admin/users?page=' + page + '&organization=' + organization_search + '&role_id=' + type + '&product=' + rootState.persist.selectedProduct)
          .then((response) => {
            let res = response.data;
            commit('SET_USERS', res.data);

            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
          });

      } else {
        await axios.get('/admin/users?page=' + page + '&organization=' + organization_search + '&role_id=' + type + '&product=' + rootState.persist.selectedProduct)
          .then((response) => {
            let res = response.data;
            let resultantArray = res.data;
            
            if(type == ""){
              let newArray = [];
              $.each(res.data, function(key, value) {
                if(value.role_id != 1){
                  newArray.push(value);
                }
              });
              resultantArray = newArray;
            }
            
            commit('SET_USERS', resultantArray);

            let totalPages = Math.ceil(resultantArray.length / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
          });
      }

    }

  },
  async getusersBySearch({ commit, state, rootState }, [search,role_id]) {
    await axios.get('/admin/users?search=' + search + '&role_id='+ role_id +'&product=' + rootState.persist.selectedProduct )
      .then((response) => {
        let res = response.data;
        let resultantArray = res.data;   
        if(role_id == ""){
          let newArray = [];
          $.each(res.data, function(key, value) {
            if(value.role_id != 1){
              newArray.push(value);
            }
          });
          resultantArray = newArray;
        }
        commit('SET_USERS', resultantArray);
        let totalPages = Math.ceil(res.total/ res.per_page);
        commit('SET_TOTAL_PAGES', totalPages);
      });
  },
  async getdemoBySearch({ commit }, [page, search = "", status, request_from = "", request_to = "", follow_up_from = "", follow_up_to = "", direction = "", column = "", color = ""]) {
    if(hasPermission('lead_create_organization')){
      const permission = {
        headers: {
          'X-Permission': 'lead_create_organization'
        }
      };
      await axios.get('/admin/users/get-demo-requests?page=' + page + '&baned=' + '&follow_up_from=' + follow_up_from + '&follow_up_to=' + follow_up_to + '&status=' + status + '&request_from=' + request_from + '&request_to='
          + request_to + '&direction=' + direction + '&column=' + column + '&color=' + color + '&search=' + search+ '&lead_for=' +localStorage.getItem('product'),permission)
          .then((response) => {
            let res = response.data;
            commit('SET_DEMO_REQUESTS', res.data);
            commit('SET_TOTAL_LEADS', res.total);
            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
            commit('SET_TOTAL_ROWS', res.data.length);
          }).catch(error => {
            console.log(error.response)
          });
    }
  },
  async getleadsBySearch({ commit }, [page, search = "", status, request_from = "", request_to = "", follow_up_from = "", follow_up_to = "", direction = "", column = "", color = "", tab]) {
    if(hasPermission('onboarding_list')){
      const permission = {
        headers: {
          'X-Permission': 'onboarding_list'
        }
      };
      await axios.get('/admin/users/get-demo-leads?page=' + page + '&baned=' + '&follow_up_from=' + follow_up_from + '&follow_up_to=' + follow_up_to + '&status=' + status + '&request_from=' + request_from + '&request_to=' + request_to + '&direction=' + direction + '&column=' + column + '&color=' + color + '&search=' + search + '&tab=' + tab,permission)
          .then((response) => {
            let res = response.data;
            commit('SET_DEMO_LEADS', res.data);
            // commit('SET_TOTAL_LEADS', res.displayRows);
            commit('SET_TOTAL_LEADS', res.total);
            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
            commit('SET_TOTAL_ROWS',res.displayRows);
            // commit('SET_DEMO_LEADS', resposed_array);
            // commit('SET_TOTAL_LEADS', resposed_array.length);
            // let totalPages = Math.ceil(resposed_array.length / res.per_page);
            // commit('SET_TOTAL_PAGES', totalPages);
            // if ((resposed_array.length % res.per_page) == 0) {
            //   commit('SET_TOTAL_ROWS', res.per_page);
            // } else {
            //   commit('SET_TOTAL_ROWS', (resposed_array.length % res.per_page));
            // }
          }).catch(error => {
            console.log(error.response)
          });
    }
  },
  // async getusersByOrgStatus({commit},[page,type,status]){
  //   await axios.get('/admin/users?page=' + page + '&role_id=' + type +'&status=' + status)
  //   .then((response) => {
  //     console.log("orgStatus", response, response.data);
  //   });
  // },
  async getusersByType({ commit, state, rootState }, [page,org_type, type, search,org_id]) {
    // await axios.get('/admin/users?page=' + page + '&organization=' + organization_search)
    // if (!organization_search || organization_search == 'all') {
          commit('SET_STATUS', org_type);
          commit('SET_TYPE', type);
          commit('SET_SEARCH', search);
          commit('SET_SELECTED_ORG',org_id);
          commit('SET_USER_CURRENT_PAGE',page);
          let org_ids  = (org_id!='' && org_id!=undefined && org_id!=null)?org_id.map(({ organization_id }) => organization_id): '';
          let role_id = (type!='' && type!=undefined && type!=null)?type.map(({ value }) => value):'';
          let org_status  = (org_type!='' && org_type!=undefined && org_type!=null)? org_type.map(({ value }) => value):'';
          
          // Build URL with proper parameter handling
          let url = '/admin/users?page=' + page;
          if (org_status && org_status.length > 0) url += '&status=' + org_status;
          if (role_id && role_id.length > 0) url += '&role_id=' + role_id;
          if (search) url += '&search=' + search;
          if (org_ids && org_ids.length > 0) url += '&organization=' + org_ids;
          url += '&product=' + (rootState.persist.selectedProduct || 0);
          
      await axios.get(url)
        .then((response) => {
          let res = response.data;
          commit('SET_USERS', res.data);
          
          let totalPages = Math.ceil(res.total / res.per_page);
          commit('SET_TOTAL_PAGES', totalPages);
        })
        .catch((error) => {
          console.error("API error:", error);
        });
    // } else {
    //   await axios.get('/admin/users?page=' + page + '&role_id=' + type + '&organization=' + organization_search + '&product=' + state.selectedProduct)
    //     .then((response) => {
    //       let res = response.data;
    //       commit('SET_USERS', res.data);

    //       let totalPages = Math.ceil(res.total / res.per_page);
    //       commit('SET_TOTAL_PAGES', totalPages);
    //     });
    // }

  },


  async getBannedUsers({ commit }, page) {
    await axios.get('/admin/users/banned?page=' + page)
      .then((response) => {
        let res = response.data;
        commit('SET_USERS', res.data);

        let totalPages = Math.ceil(res.total / res.per_page);
        commit('SET_TOTAL_PAGES', totalPages);
      });
  },


  async searchUsers({ commit }, query) {
    return await axios.get('/admin/users/search?q=' + query)
      .then((response) => {
        // commit('SET_USERS_SEARCH', response.data);
        commit('SET_USERS_SEARCH', response.data.data);
      });
  },

  // =========================================================================

  async getUser({ commit }, user) {
    alert(1)
    await axios.get('/admin/users/' + user)
      .then((response) => {
        commit('SET_USER', response.data.user)
      });
  },
//===================================================================



  // =========================================================================

  assignRole({ commit }, payload) {
    axios.post('/admin/users/' + payload.user.master_user_id + '/assign-role', {
      role: payload.role
    })
      .then((res) => {
        payload.user.send_update_email = payload.send_update_email;
        commit('UPDATE_USER', payload.user);
      });
  },

  // =========================================================================

  deleteUser({ commit }, user) {
    axios.post('/admin/users/' + user.id, {
      '_method': 'DELETE'
    })
      .then((response) => {
        commit('DELETE_USER', user);
        return response;
      });
  },

  // =======================Get Master Users List=============================

  async get_master_users_list({ commit }, [page, organization_search]) {
    // let orgnazation_perm = (!organization_search || organization_search == 'all') ?
    //   '&organization=' + organization_search : organization_search;
    let orgnazation_perm =  '&organization=' + organization_search;
    await axios.get('/admin/users?role_id=1&page=' + page  + orgnazation_perm)
      .then((response) => {
        let res = response.data;
        commit('SET_USERS', res.data);

        let totalPages = Math.ceil(res.total / res.per_page);
        commit('SET_TOTAL_PAGES', totalPages);
      });
  },

  // =======================Get Master User Detail=============================

  async get_master_user({ commit }, [id]) {
    if (id != undefined) {
      await axios.get('/admin/get-master-user/' + id)
        .then((response) => {
          let res = response.data;
          commit('SET_USER', res.user);
        });
    } else {
      commit('SET_USER', {});
    }
  },
  async checkLeadsWebsiteStatus({ commit },[url,id,lead_for]) {
    if(url!= '' && hasPermission('lead_create_website')){
      const permission = {
        headers: {
          'X-Permission': 'lead_create_website'
        }
      };
      return await axios.get('/admin/users/check-leads-website-status?url='+url+'&id='+id+'&lead_for='+lead_for,permission)
          .then((response) => {
            return response.data.error;
        });
    }else{
      return '';
    }
  }, 
  async dataAttachmentLink({ commit },[lead_id,lead_onboarding_id,send_attachment_link=false]){
    if(hasPermission('onboarding_send_attachment_link')){
      const permission = {
        headers: {
          'X-Permission': 'onboarding_send_attachment_link'
        }
      };
      return  axios.post('/admin/users/send-meeting-link',{lead_id,lead_onboarding_id,send_attachment_link
      },permission)
          .then((response) => {
            return response.data;
          }).catch(error => {
            this.$toast.error('OOPS! Something Went Wrong...');
          });
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
